/* ACCOUNT_STATEMENTS */
export const GET_BANK_STATEMENTS = "GET_BANK_STATEMENTS";
export const GET_BANK_STATEMENTS_SUCCESS = "GET_BANK_STATEMENTS_SUCCESS";
export const GET_BANK_STATEMENTS_FAIL = "GET_BANK_STATEMENTS_FAIL";
